import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel,
  DataModelBuilder,
  SerializationContext,
  SerializedData,
} from '../dto/dto.js';

export class ModuleSettings extends DataModel {
  static readonly TYPE_ID: string = '59b2ac5879e04b9aa7593662b6c4785a';

  private constructor(
    public readonly isPassesEnabled: boolean,
    public readonly isVouchersEnabled: boolean,
    public readonly isProductsEnabled: boolean,
    public readonly isMarketingEnabled: boolean,
    public readonly isPromotersEnabled: boolean,
    public readonly isReservationsEnabled: boolean,
    public readonly isProductionsEnabled: boolean,
    public readonly isDonationsEnabled: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return ModuleSettings.TYPE_ID;
  }

  static create(args: {
    isPassesEnabled: boolean,
    isVouchersEnabled: boolean,
    isProductsEnabled: boolean,
    isMarketingEnabled: boolean,
    isPromotersEnabled: boolean,
    isReservationsEnabled: boolean,
    isProductionsEnabled: boolean,
    isDonationsEnabled: boolean,
  }): ModuleSettings {
    return new ModuleSettings(
        args.isPassesEnabled,
        args.isVouchersEnabled,
        args.isProductsEnabled,
        args.isMarketingEnabled,
        args.isPromotersEnabled,
        args.isReservationsEnabled,
        args.isProductionsEnabled,
        args.isDonationsEnabled,
    );
  }

  static empty(): ModuleSettings {
    return ModuleSettings.create({
      isPassesEnabled: true,
      isVouchersEnabled: true,
      isProductsEnabled: true,
      isMarketingEnabled: true,
      isPromotersEnabled: true,
      isReservationsEnabled: true,
      isProductionsEnabled: true,
      isDonationsEnabled: true,
    });
  }

  static fromMap(context: SerializationContext, map: SerializedData): ModuleSettings {
    return ModuleSettings.create({
      isPassesEnabled: MapUtils.getBoolean(map, 'isPassesEnabled'),
      isVouchersEnabled: MapUtils.getBoolean(map, 'isVouchersEnabled'),
      isProductsEnabled: MapUtils.getBoolean(map, 'isProductsEnabled'),
      isMarketingEnabled: MapUtils.getBoolean(map, 'isMarketingEnabled'),
      isPromotersEnabled: MapUtils.getBoolean(map, 'isPromotersEnabled'),
      isReservationsEnabled: MapUtils.getBoolean(map, 'isReservationsEnabled'),
      isProductionsEnabled: MapUtils.getBoolean(map, 'isProductionsEnabled'),
      isDonationsEnabled: MapUtils.getBoolean(map, 'isDonationsEnabled'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'isPassesEnabled': this.isPassesEnabled,
      'isVouchersEnabled': this.isVouchersEnabled,
      'isProductsEnabled': this.isProductsEnabled,
      'isMarketingEnabled': this.isMarketingEnabled,
      'isPromotersEnabled': this.isPromotersEnabled,
      'isReservationsEnabled': this.isReservationsEnabled,
      'isProductionsEnabled': this.isProductionsEnabled,
      'isDonationsEnabled': this.isDonationsEnabled,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    isPassesEnabled = this.isPassesEnabled,
    isVouchersEnabled = this.isVouchersEnabled,
    isProductsEnabled = this.isProductsEnabled,
    isMarketingEnabled = this.isMarketingEnabled,
    isPromotersEnabled = this.isPromotersEnabled,
    isReservationsEnabled = this.isReservationsEnabled,
    isProductionsEnabled = this.isProductionsEnabled,
    isDonationsEnabled = this.isDonationsEnabled,
  }: {
    isPassesEnabled?: boolean,
    isVouchersEnabled?: boolean,
    isProductsEnabled?: boolean,
    isMarketingEnabled?: boolean,
    isPromotersEnabled?: boolean,
    isReservationsEnabled?: boolean,
    isProductionsEnabled?: boolean,
    isDonationsEnabled?: boolean,
  } = {}): this {
    return ModuleSettings.create({
      isPassesEnabled,
      isVouchersEnabled,
      isProductsEnabled,
      isMarketingEnabled,
      isPromotersEnabled,
      isReservationsEnabled,
      isProductionsEnabled,
      isDonationsEnabled,
    }) as this;
  }

  isSame(other: ModuleSettings): boolean {
    if(other === this) {
      return true;
    }

    return other.isPassesEnabled === this.isPassesEnabled &&
      other.isVouchersEnabled === this.isVouchersEnabled &&
      other.isProductsEnabled === this.isProductsEnabled &&
      other.isMarketingEnabled === this.isMarketingEnabled &&
      other.isPromotersEnabled === this.isPromotersEnabled &&
      other.isReservationsEnabled === this.isReservationsEnabled &&
      other.isProductionsEnabled === this.isProductionsEnabled &&
      other.isDonationsEnabled === this.isDonationsEnabled;
  }
}

export class ModuleSettingsBuilder extends DataModelBuilder<ModuleSettings> {
  build(context: SerializationContext, map: SerializedData): ModuleSettings {
    return ModuleSettings.fromMap(context, map);
  }
}
